import React from 'react';
import './IdentitySelector.css';

const IdentitySelector = ({ driverName, passengerName, onSelect, onClose }) => {
  return (
    <div className="identity-selector-overlay" onClick={onClose}>
      <div className="identity-selector-container" onClick={(e) => e.stopPropagation()}>
        <div className="identity-selector-header">
          <h3>Qui êtes-vous ?</h3>
          <button className="identity-selector-close" onClick={onClose}>✕</button>
        </div>
        <div className="identity-selector-options">
          <button
            className="identity-option identity-option-driver"
            onClick={() => onSelect(driverName)}
          >
            <span className="identity-option-icon">🚗</span>
            <span className="identity-option-name">{driverName}</span>
            <span className="identity-option-label">Conducteur</span>
          </button>
          <button
            className="identity-option identity-option-passenger"
            onClick={() => onSelect(passengerName)}
          >
            <span className="identity-option-icon">👤</span>
            <span className="identity-option-name">{passengerName}</span>
            <span className="identity-option-label">Passager</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default IdentitySelector;
